<template>
    <div class>
        <el-card shadow="never">
            <div slot="header">
                <span class="title">道闸信息</span>
            </div>
            <div class style="width:400px;margin-top:20px;">
                <!-- <SForm
                ref="firstForm"
                :fields="firstFormfields"
                :dataForm="rowdata"
                labelWidth="150px"
                :isShowBtn="false"
                :inline="false"
                formStyle="width: 500px;"
            >
            </SForm> -->
                <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-form-item label="道闸品牌" prop="name">
                        <el-select v-model="form.name" placeholder="请选择道闸品牌" style="width: 100%;">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="接入场站" prop="stationId">
                        <el-select v-model="form.stationName" filterable remote reserve-keyword placeholder="请输入搜索关键词"
                            :remote-method="getStation" style="width: 100%;">
                            <el-option v-for="item in staionList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="车场ID" prop="carId">
                        <el-input v-model="form.carId" placeholder="请输入车场ID" style="width: 100%;" />
                    </el-form-item>
                    <el-form-item label="应用ID" prop="appId">
                        <el-input v-model="form.appId" placeholder="请输入应用ID" style="width: 100%;" />
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model="form.code" placeholder="请输入验证码" style="width: 100%;" />
                    </el-form-item>
                    <el-form-item label="订单推送地址" prop="url">
                        <el-input v-model="form.url" placeholder="请输入订单推送地址" style="width: 100%;" />
                    </el-form-item>
                    <el-form-item label="停车场名称" prop="portName">
                        <el-input v-model="form.portName" placeholder="请输入停车场名称" style="width: 100%;" />
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
        </div>
    </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
    name: 'Xiugaidaozha',
    components: {},
    data() {
        return {
            options: [
                {
                    label: '科拓',
                    value: '科拓'
                },
                {
                    label: '中安智谷',
                    value: '中安智谷'
                },
                {
                    label: '江南大院',
                    value: '江南大院'
                },
                {
                    label: '立方',
                    value: '立方'
                },
                {
                    label: '宁波道闸',
                    value: '宁波道闸'
                },
                {
                    label: '湖州道闸',
                    value: '湖州道闸'
                }
            ],
            staionList: {},
            form: {
                name: '',
                stationId: '',
                stationName: '',
                carId: '',
                appId: '',
                code: '',
                url: '',
                portName: ''
            },
            rules: {
                name: [
                    { required: true, message: '请选择道闸品牌', trigger: 'blur' }
                ],
                stationId: [
                    { required: true, message: '请选择归属电站', trigger: 'blur' }
                ],
                carId: [
                    { required: true, message: '请输入车场ID', trigger: 'blur' }
                ],
                appId: [
                    { required: true, message: '请输入应用ID', trigger: 'blur' }
                ],
                // code: [
                //   { required: true, message: '请输入验证码', trigger: 'blur' }
                // ],
                url: [
                    { required: true, message: '请输入订单推送地址', trigger: 'blur' }
                ],
                // portName: [
                //   { required: true, message: '请输入停车场名称', trigger: 'blur' }
                // ]
            }
        }
    },
    computed: {},
    mounted() { },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() {
        this.id = this.$route.query.data
        this.$store.dispatch('form/handle', {
            url: '/business/brake/getDataDetail',
            data: { id: this.$route.query.data },
            callback: resp => {
                if (resp) {
                    this.form = resp
                }
            }
        })
    }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { },
    methods: {
        cancel() {
            this.$router.go(-1)
        },
        async save() {
            try { // 必填校验
                await Promise.all([
                    this.$refs.form.validate()
                ])
            } catch (error) {
                return
            }
            const data = {
                id: this.id,
                name: this.form.name,
                stationId: this.form.stationId,
                carId: this.form.carId,
                appId: this.form.appId,
                code: this.form.code,
                url: this.form.url
            }
            this.$store.dispatch('form/handle', {
                url: '/business/brake',
                method: 'post',
                data: data,
                callback: resp => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    })
                    this.$router.go(-1)
                }
            })
        },
        getStation(val) {
            const data = {
                stationName: val
            }
            this.$store.dispatch('form/handle', {
                url: '/business/brake/getStationByName',
                data: data,
                callback: resp => {
                    if (resp) {
                        this.staionList = resp
                    }
                }
            })
        }
    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/reviseGate.vue